import {
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { WizardSection } from '@app/models/project-setup.models';
import { WizardStore } from '@app/stores/project-setup/wizard.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { ValidatedTextAreaComponent } from '@app/ui-components/validated-textarea/validated-textarea.component';
import { SectionHFormGroup } from '../+helpers/section-h-form.helper';

@Component({
  selector: 'app-section-h',
  imports: [ReactiveFormsModule, CardComponent, ValidatedTextAreaComponent],
  templateUrl: './section-h.component.html',
  styleUrl: './section-h.component.scss',
})
export class SectionHComponent implements OnInit {
  wizardStore = inject(WizardStore);
  projectId = input.required<string>();
  protected formGroup = signal<FormGroup<SectionHFormGroup> | null>(null);
  protected translationKey = 'projectWizard.sectionHForm.';

  constructor(private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.wizardStore
      .getSection(this.projectId(), WizardSection.H)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) =>
        this.formGroup.set(data as FormGroup<SectionHFormGroup>)
      );
  }
}
